import { useIntl } from 'react-intl';
import { IconCustomMenuDown, IconCustomMenuUp } from '@rossum/ui/icons/tabler';
import { Button, SvgIcon } from '@rossum/ui/material';

type ShowMoreButtonProps = {
  expanded: boolean;
  onClick: (expand: boolean) => void;
};

export const ShowMoreButton = ({ onClick, expanded }: ShowMoreButtonProps) => {
  const intl = useIntl();
  return (
    <Button
      color="secondary"
      onClick={() => onClick(!expanded)}
      startIcon={
        <SvgIcon fontSize="large">
          {expanded ? <IconCustomMenuUp /> : <IconCustomMenuDown />}
        </SvgIcon>
      }
      size="small"
      sx={{ alignSelf: 'flex-start', ml: 4 }}
      data-cy={expanded ? 'show-less-attachments' : 'show-more-attachments'}
    >
      {intl.formatMessage({
        id: expanded
          ? 'components.emailDocumentsPreview.button.showLess'
          : 'components.emailDocumentsPreview.button.showAll',
      })}
    </Button>
  );
};
